import React from 'react';
// javascipt plugin for creating charts
import Chart from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { isEmpty, map, toNumber } from 'lodash-es';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
import { isFloat } from '../../utils/misc';
import { Spinner } from 'reactstrap';
import {
  useGeneralHostAnalytics,
  useHostGeneralAnalyticsByMonth,
  useHostGeneralAnalyticsByYear,
} from '../../utils/queries/hostQueries';
import ChartDataLabels from 'chartjs-plugin-datalabels';
parseOptions(Chart, chartOptions());
Chart.plugins.register(ChartDataLabels);

export default function DurationTimeCustomerChart({
  granularity,
  handleBarClick,
  selectedBarIndex = -1,
}) {
  const { data: dailyData, isLoading, error } = useGeneralHostAnalytics();
  const { data: monthlyData } = useHostGeneralAnalyticsByMonth();
  const { data: yearlyData } = useHostGeneralAnalyticsByYear();

  let data = dailyData;

  if (granularity === 'monthly') {
    data = monthlyData;
  }
  if (granularity === 'yearly') {
    data = yearlyData;
  }
  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }
  const defaultBarColor = '#fb6340';
  const selectedBarColor = '#414141';
  let chartData = {
    options: {
      scales: {
        yAxes: [
          {
            display: false,
          },
        ],
      },
      tooltips: {
        enabled: false,
      },
      layout: {
        padding: {
          top: 50,
        },
      },
      onClick: (evt, ele) => {
        handleBarClick(
          granularity,
          data[ele[0]?._index]?.DATE,
          'energySold',
          ele[0]?._index,
        );
      },
    },
    plugins: [ChartDataLabels],
    data: {
      labels: map(data, (row) => {
        return row.DATE;
      }),
      datasets: [
        {
          label: 'Total kWh Sold',
          data: map(data, (row) => {
            return isFloat(toNumber(row.KWH))
              ? toNumber(row.KWH).toFixed(2)
              : toNumber(row.KWH);
          }),
          backgroundColor: map(data, (row, index) =>
            index === selectedBarIndex ? selectedBarColor : defaultBarColor,
          ),
          maxBarThickness: 10,
          datalabels: {
            font: {
              weight: 400,
              size: '12',
            },
            color: 'black',
            backgroundColor: 'transparent',
            align: 'start',
            anchor: 'end',
            clamp: true,
            offset: -25,
            borderRadius: 5,
            padding: 4,
            opacity: 0.8,
            textAlign: 'center',
            formatter: function (value, context) {
              return `${value} kWh`;
            },
            listeners: {
              click: (context) => {
                handleBarClick(granularity, data[context.dataIndex]?.DATE);
              },
            },
          },
        },
      ],
      backgroundColor: '#000000',
    },
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '400px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#2675b8' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : isEmpty(data) ? (
          'We dont have any Analytics report'
        ) : (
          <Bar data={chartData.data} options={chartData.options} />
        )}
      </div>
    </>
  );
}
